import { useMutation, useQuery } from '@apollo/react-hooks';
import { useAccount, useLogin } from '@bnnvara/accounts';
import { useEffect, useState } from 'react';

import { followRequest } from '../../api/mutations/brandFollow.gql';
import { FetchIsBrandFollowed } from '../../api/queries/me/brand.gql';

export function useIsFollowedByUser(brandId) {
  const { login, isLoggedIn, status } = useLogin();
  const [isFollowedByUser, setIsFollowedByUser] = useState(undefined);
  const {
    token,
    profile: { UID },
  } = useAccount();
  const [followContent] = useMutation(followRequest);
  const { data } = useQuery(FetchIsBrandFollowed, {
    variables: {
      interactionId: brandId,
      userId: UID,
    },
    skip: !UID,
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (status !== 'idle') {
      return;
    }

    if (isLoggedIn === false) {
      setIsFollowedByUser(false);
      return;
    }

    if (data?.me) {
      setIsFollowedByUser(data.me.isBrandFollowed);
    }
  }, [data, status]);

  /**
   * This function returns:
   * - `null` when not logged in
   * - `true` when following
   * - `false` when unfollowing
   */
  function toggle() {
    if (!isLoggedIn) {
      login();

      return null;
    }

    const newValue = !isFollowedByUser;
    setIsFollowedByUser(newValue);

    followContent({
      variables: {
        interactionId: brandId,
        token,
      },
    });

    return newValue;
  }

  return {
    isFollowedByUser,
    toggle,
  };
}
